import { createSelector } from 'reselect';
import columns from '../../../../../react-table/helpers/columns';
import { operatorNumberedMailboxColumns } from '../../../common/CarditResditByPostMetadataMapper';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';

export const getData = ReportsDefinition.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.getDataFunction();

const getMetadata = state => state.reporting.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.metadata;

export const getGeneratedOnDateTime = state =>
  getMetadata(state) && getMetadata(state).generatedOnDateTime;

export const getIsLoading = state => state.reporting.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.isLoading;

export const getUserType = state => state.userData.userType;

export function backgroundProps() {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo.row.version !== '2.1') {
      className = 'bg-orange-amber';
    }
    return {
      className,
    };
  });
}

export const getColumns = createSelector(getMetadata, getData, (metadata, data) => {
  if (!metadata || !metadata.columns) {
    return [];
  }
  const { TextColumn } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Airline', 'firstColumnName'),
        new TextColumn('Mailbox', 'mailbox'),
        new TextColumn('Version', 'version'),
      ],
    }, ...operatorNumberedMailboxColumns(metadata.columns.slice(3), data),
  ];
});
